
import { useUserListStore } from '~/store/userLists'

export default {
  async asyncData(context) {
    // Проверяем, это ссылка, которой с пользователем поделились.
    // Если она является такой, добавляем товары в сравнение (API и userLists)
    if (context.query.shared) {
      try {
        await context.$api.compare.add(context.query.shared)
        // Разбиваем строку с ID товаров на массив, потом преобразуем этот массив в формат, который подходит для pinia
        const compareProductsArray = context.query.shared.split(',')
        const compareProductsObject = {}
        const userListStore = useUserListStore(context.$pinia)
        compareProductsArray.forEach((el) => {
          compareProductsObject[el] = true
        })

        await userListStore.setList({
          type: 'compare',
          list: { ...userListStore.compare, ...compareProductsObject },
        })
      }
      catch (error) {
        new context.$simpleError({
          message: 'Ошибка при попытке добавления товара в сравнение',
          native: error,
        })
      }
    }
  },
  head: {
    title: 'Сравнение товаров',
  },
}
